import { Stream } from './stream';
import { Podcast } from './podcast';

export class Episode extends Stream {

    public podcast: Podcast;

    public description: string;
    public explicitContent: boolean;

    public audioLengthSec: string;

    public thumbnail: string;

    public pubDateMs: number;

    public static fromResponseData(data: object): Episode {
        const episode = new Episode();

        episode.id = data['id'];
        episode.title = data['title_original'] !== undefined ? data['title_original'] : data['title'];
        episode.description = data['description_original'] !== undefined ? data['description_original'] : data['description'].replace(/<[^>]*>/g, '');
        episode.explicitContent = data['explicit_content'];

        episode.url = data['audio'];
        episode.audioLengthSec = new Date(data['audio_length_sec'] * 1000).toISOString().substr(11, 8);

        episode.logo = data['image'];
        episode.thumbnail = data['thumbnail'];

        episode.pubDateMs = data['pub_date_ms'];

        return episode;
    }
}